import _ from 'lodash';
import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@telecom/shared/utils/language-tool';
import { i18nDeferred } from './deferred';
import type { I18nChunk } from '@/types';

const ENMessage: I18nChunk = [
    import('CommonMessages/drafting-common-patent/en.json'),
    import('CommonMessages/drafting-common-country/en.json'),
    import('CommonMessages/main/en.json'),
    import('element-plus/dist/locale/en.mjs'),
    import('@/presentation/pages/oar/locales/en.json'),
    import('@/presentation/components/agent-input/locales/en.json'),
];

const CNMessage: I18nChunk = [
    import('CommonMessages/drafting-common-patent/cn.json'),
    import('CommonMessages/drafting-common-country/cn.json'),
    import('CommonMessages/main/cn.json'),
    import('element-plus/dist/locale/zh-cn.mjs'),
    import('@/presentation/pages/oar/locales/cn.json'),
    import('@/presentation/components/agent-input/locales/cn.json'),
];

const TWMessage: I18nChunk = [
    import('CommonMessages/drafting-common-patent/tw.json'),
    import('CommonMessages/drafting-common-country/tw.json'),
    import('CommonMessages/main/tw.json'),
    import('element-plus/dist/locale/zh-tw.mjs'),
    import('@/presentation/pages/oar/locales/cn.json'),
    import('@/presentation/components/agent-input/locales/tw.json'),
];

const JPMessage: I18nChunk = [
    import('CommonMessages/drafting-common-patent/jp.json'),
    import('CommonMessages/drafting-common-country/jp.json'),
    import('CommonMessages/main/jp.json'),
    import('element-plus/dist/locale/ja.mjs'),
    import('@/presentation/pages/oar/locales/en.json'),
    import('@/presentation/components/agent-input/locales/jp.json'),
];

function createI18nInstance(locale?: string) {
    locale = locale || getCurrentLanguage();
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: 'en',
        messages: {},
    });
}

const i18n = createI18nInstance();

async function mergeMessages(messages: I18nChunk) {
    const results = await Promise.all(messages);
    return results?.reduce((obj, { default: messageData }) => {
        return _.merge(obj, messageData);
    }, {});
}



async function loadI18n() {
    const lang = getCurrentLanguage();
    const langMessages = {
        cn: CNMessage,
        en: ENMessage,
        jp: JPMessage,
        tw: TWMessage,
    };

    const messages = langMessages[lang] || langMessages.en;
    const data = await mergeMessages(messages);

    if (data) {
        i18n.global.setLocaleMessage(lang, data);
    }

    i18nDeferred.resolve();

    return i18n;
}

export {
    i18n,
    loadI18n,
};
